module.exports = __webpack_public_path__ + "img/Abdul.23e2f51a.jpeg";